// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Currency from "../../../../../../../../library/data-source/country-currency/Currency.bs.js";

function getVm(pricings, symbol) {
  return List.map((function (p) {
                return {
                        upper_km: p.upper_km.toString() + " kms",
                        lower_km: p.lower_km.toString() + " kms",
                        price_per_km: Currency.toCurrencyString(p.price_per_km, symbol),
                        price_per_min: Currency.toCurrencyString(p.price_per_min, symbol)
                      };
              }), pricings);
}

export {
  getVm ,
  
}
/* No side effect */
